import React from 'react';
import PropTypes from 'prop-types';
import './SquareButton.scss';

const plusImage = require('./assets/plus.svg');

const propTypes = {
  clickHandler: PropTypes.func.isRequired,
};


const SquareButton = ({ clickHandler }) => (
  <div className="square-button-wrapper">
    <button onClick={clickHandler} className="square-button">
      <img src={plusImage} alt="add" />
    </button>
    <div className="square-button-label">
        Add new
    </div>
  </div>
);


SquareButton.propTypes = propTypes;


export default SquareButton;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/components/SquareButton/SquareButton.js